const modalDirective = (app) => {
  app.directive('modal', {
    mounted: (el, binding) => {
      el.dataset.toggle = 'modal';
      el.dataset.target = '#' + binding.value;
    },
  });
};

export default modalDirective;
